import secondaryComponents from "../..";
import { truncateString } from "../../../../helpers";
import { RoutedModal } from "../../../common";
import { CancelSmsCampaign } from "../CancelSmsCampaign";
import { DeleteSmsCampaign } from "../DeleteSmsCampaign";
import { useSmsCampaignTable } from "./useSmsCampaignTable";

export const SmsCampaignTable = ({
  campaigns = [],
  metaDetails,
  gotoPage = () => {},
}) => {
  const {
    instance,
    deleteCampaign,
    cancelCampaign,
    setCancelCampaign,
    setDeleteCampaign,
  } = useSmsCampaignTable({
    campaigns,
  });
  const { getTableBodyProps, getTableProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <>
      <secondaryComponents.TableHelper
        getTableBodyProps={getTableBodyProps}
        getTableProps={getTableProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
        hasAction={true}
      >
        <div className="pt-5 text-center">
          <h4>You have no SMS Campaigns </h4>
          <p>
            Use the button above to create an sms campaign When you do, they
            would appear here.
          </p>
        </div>
      </secondaryComponents.TableHelper>

      {/* pagination */}
      {campaigns?.length > 0 && (
        <div className="mt-auto">
          <secondaryComponents.Pagination
            totalPageNumber={metaDetails?.last_page}
            handlePageClick={(value) => gotoPage(value?.selected + 1)}
            currentPage={metaDetails?.current_page}
          />
        </div>
      )}

      <RoutedModal
        headerTitle={`Delete Campaign: ${truncateString(deleteCampaign?.title, 25)}`}
        isActive={!!deleteCampaign}
        width={500}
        closeModal={() => setDeleteCampaign(null)}
        style={{ height: "auto" }}
      >
        <DeleteSmsCampaign
          selectItem={deleteCampaign}
          closeModal={() => setDeleteCampaign(null)}
        />
      </RoutedModal>

      <RoutedModal
        headerTitle={`Pause Campaign: ${truncateString(cancelCampaign?.title, 25)}`}
        isActive={!!cancelCampaign}
        width={500}
        closeModal={() => setCancelCampaign(null)}
        style={{ height: "auto" }}
      >
        <CancelSmsCampaign
          selectItem={cancelCampaign}
          closeModal={() => setCancelCampaign(null)}
        />
      </RoutedModal>
    </>
  );
};
